import * as React from 'react';

const CalculatorMobileLogoSVGR = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width={80} height={97}>
    <defs>
      <clipPath id='calc-img-a'>
        <path d='M24 16h56v81H24z' />
      </clipPath>
      <clipPath id='calc-img-b'>
        <path d='M24 97h56V16H24z' />
      </clipPath>
    </defs>
    <path fill='#00604b' d='M37.222 62.286h2.334V50.714h-2.334z' />
    <path fill='#00604b' d='M32.556 57.657h11.666v-2.314H32.556zM35.027 87.743l-1.694-1.68 8.418-8.349 1.693 1.68z' />
    <path fill='#00604b' d='m41.751 87.743-8.418-8.35 1.694-1.679 8.417 8.35zM59.778 57.657h11.666v-2.314H59.778zM62.25 87.743l-1.694-1.68 8.417-8.349 1.694 1.68zM63.21 78.166c.609.603.609 1.58 0 2.182a1.564 1.564 0 0 1-2.199 0 1.533 1.533 0 0 1 0-2.182 1.564 1.564 0 0 1 2.2 0M70.21 84.338a1.533 1.533 0 0 1 0 2.181 1.564 1.564 0 0 1-2.199 0 1.533 1.533 0 0 1 0-2.181 1.564 1.564 0 0 1 2.2 0' />
    <g>
      <path fill='#00604b' d='M28.266 97C25.914 97 24 95.107 24 92.78V20.22c0-2.327 1.914-4.22 4.266-4.22h47.47C78.086 16 80 17.893 80 20.22v72.56c0 2.327-1.913 4.22-4.265 4.22zm-.01-78.686c-1.06 0-1.923.853-1.923 1.9v72.571c0 1.048.863 1.9 1.923 1.9h47.49c1.058 0 1.92-.852 1.92-1.9v-72.57c0-1.048-.862-1.9-1.92-1.9z' />
    </g>
    <g>
      <path fill='#00604b' d='M24 23.714h56v20.057H24zm2.333 17.743h51.334V26.03H26.333z' />
    </g>
    <g>
      <path fill='#00604b' d='M25.556 70.771h53.666v-2.314H25.556z' />
    </g>
    <g>
      <path fill='#00604b' d='M50.444 95.457h2.334V42.23h-2.334z' />
    </g>
    <g>
      <path fill='#00604b' d='M68.333 35.286h3.111V32.97h-3.11zm-6.222 0h3.111V32.97h-3.11zm-6.222 0H59V32.97h-3.111z' />
    </g>
    <path
      fill='#19a683'
      d='M20.202 24.242h-8.08a1.516 1.516 0 0 1 0-3.03h2.524v-8.788l-.928.576c-.718.504-1.635.264-2.102-.43-.46-.644-.271-1.57.384-2.046l3.322-2.188C15.789 8 16.386 8 16.878 8.26c.49.262.799.739.799 1.335v11.616h2.525c.798 0 1.515.679 1.515 1.515 0 .837-.717 1.515-1.515 1.515zM16.162 0C7.235 0 0 7.235 0 16.162c0 8.926 7.235 16.161 16.162 16.161 8.926 0 16.161-7.235 16.161-16.161C32.323 7.235 25.088 0 16.162 0z'
    />
  </svg>
);

export default CalculatorMobileLogoSVGR;
